import { getCoreSonarObjectsPageLayoutsAsyncSlice } from './get';

export const { requestGetCoreSonarObjectsPageLayouts, resetGetCoreSonarObjectsPageLayouts } =
	getCoreSonarObjectsPageLayoutsAsyncSlice.asyncActionCreators;
